export function operacaoMedicaoTemperaturasInRequest(params = {}) {
  return {
    type: '@operacaomedicaotemperatura/OPERACAOMEDICAOTEMPERATURAS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoMedicaoTemperatura(id) {
  return {
    type: '@operacaomedicaotemperatura/FIND_OPERACAOMEDICAOTEMPERATURA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaomedicaotemperatura/FAILED_REQUEST',
  };
}

export function deleteOperacaoMedicaoTemperatura(id, params, query = {}) {
  return {
    type: '@operacaomedicaotemperatura/DELETE_OPERACAOMEDICAOTEMPERATURA',
    payload: { id, params, query },
  };
}

export function updateOperacaoMedicaoTemperatura(
  operacaomedicaotemperatura,
  params
) {
  return {
    type: '@operacaomedicaotemperatura/UPDATE_OPERACAOMEDICAOTEMPERATURA',
    payload: { operacaomedicaotemperatura, params },
  };
}

export function storeOperacaoMedicaoTemperatura(
  operacaomedicaotemperatura,
  params
) {
  return {
    type: '@operacaomedicaotemperatura/STORE_OPERACAOMEDICAOTEMPERATURA',
    payload: { operacaomedicaotemperatura, params },
  };
}

export function successInRequest(
  operacaomedicaotemperaturas,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaomedicaotemperatura/SUCCESS_IN_REQUEST',
    payload: {
      operacaomedicaotemperaturas,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaomedicaotemperatura) {
  return {
    type: '@operacaomedicaotemperatura/SUCCESS_REQUEST',
    payload: { operacaomedicaotemperatura },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaomedicaotemperatura/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaomedicaotemperatura/RECORD_FILTERING',
    payload: { params },
  };
}

export function update(data, params) {
  return {
    type: '@operacaomedicaotemperatura/UPDATE',
    payload: { data, params },
  };
}
